export default {"src":"/_next/static/media/imageFallback-6ecc21de.9555bf4e.svg","height":240,"width":240,"blurWidth":0,"blurHeight":0};